/**
 * Prefijo de ruta bajo el que se sirve la aplicacion.
 *
 * Sale de PUBLIC_URL, que lo fija el build:
 *   - VM (nginx bajo /ewan):  PUBLIC_URL=/ewan  -> basePath() === "/ewan"
 *   - Azure Static Web Apps:  PUBLIC_URL=/      -> basePath() === ""
 *
 * React Router ya aplica el basename en la navegacion declarativa. Esto es
 * para los casos que salen de React: window.location.href y comparaciones
 * contra window.location.pathname.
 *
 * Se lee en cada llamada, no al importar el modulo, para que los tests
 * puedan ejercitar las dos bases.
 */
export const basePath = () => {
  const raw = process.env.PUBLIC_URL || ""
  return raw === "/" ? "" : raw.replace(/\/$/, "")
}

/** Antepone el prefijo a un path absoluto de la app. */
export const withBase = path => `${basePath()}${path}`

/** Quita el prefijo de un path absoluto (para <Redirect>, que ya aplica
 * el basename del Router y duplicaria el prefijo). */
export const stripBase = path => {
  const base = basePath()
  return base && path.startsWith(base) ? path.slice(base.length) : path
}
